import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ModerationOrder extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId }) {
        if (!organizationId) {
            throw new Error('[ModerationOrder] OrganizationId is mandatory');
        }
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/orders`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/orders`;
    }
}
